import { render, staticRenderFns } from "./Dossiers.vue?vue&type=template&id=19c7aaef&"
import script from "./Dossiers.vue?vue&type=script&lang=js&"
export * from "./Dossiers.vue?vue&type=script&lang=js&"
import style0 from "./Dossiers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports